export default __webpack_public_path__ + "static/media/experimentalvideo_icon.ed6ece4c.svg";